




<select2 *ngIf="items.length>0" (onSelect)="onSelect($event)"
         [disabled]="disabled"
         name="select1"
         [(ngModel)]="selectedValue"
        
         [settings]="{placeholder: 'Not Selected', width: '100%'}"
         [options]="options"></select2>  


<form [formGroup]="testForm">
<!--   <form [formGroup]="testForm"> -->
  <div class="row">
    <div class="col-4">
      <p>
        <input [disabled]="disabled" />
        <select2 *ngIf="items.length>0" (onSelect)="onSelect($event)"
                 [disabled]="disabled"
                 name="testId"
                 [(ngModel)]="selectedValue"
                 formControlName="testId"
                 [settings]="{placeholder: 'Not Selected', width: '100%'}"
                 [options]="options"></select2>
        selectedValue:{{selectedValue}}
      </p>

      <!--       <p>
          <select2 (onSelect)="onSelect($event)" [disabled]="disabled" name="select1"
                      [(ngModel)]="selectedValue2"
                      [settings]="{ placeholder: 'Not Selected',width: '100%'}"
                      [options]="options2"></select2>
          selectedValue:{{selectedValue2}}
        </p>
        <p>
          <select2 [options]="statusDropdownOptions" [(ngModel)]="selectedStatusFilter"
                      [settings]="{width:'100%'}"
                      name="userDropDown" id="userDropDown"></select2>
        </p>
        selectedValue:{{selectedStatusFilter}} -->
      <!--      <p>
             <select2 (onSelect)="onSelect($event)" [disabled]="disabled" name="select1" [(ngModel)]="selectedValue" [settings]="{placeholder: 'Not Selected', width: '100%'}"
                         [options]="options"></select2>
             {{selectedValue}}
           </p>

          <!--       <p>
             <select2 (onSelect)="onSelect($event)" [disabled]="disabled" name="select2" [(ngModel)]="selectedValue2" [settings]="{placeholder: 'Not Selected', width: '100%'}"
                         [options]="options2"></select2>
             {{selectedValue2}}
           </p>
      -->
      <!--     <p>
        <select2 formControlName="testId" (onSelect)="onSelect($event)" [disabled]="disabled" name="select2" [(ngModel)]="selectedValue2" [settings]="{placeholder: 'Not Selected', width: '100%'}"
                 [options]="options"></select2>

        {{selectedValue2}}
      </p> -->
      <button class="btn btn-default" (click)="loadData()">Load Data</button>
      <button class="btn btn-default" (click)="clearData()">Clear Data</button>
      <button class="btn btn-default" (click)="setValue('2')">Set Value to 2</button>
      <button class="btn btn-default" (click)="selectedStatusFilter='All'">Select All</button>
      <button class="btn btn-default" (click)="selectedValue='';selectedValue2='';">Set Empty</button>
      <button class="btn btn-default" (click)="selectedValue=null;selectedValue2=null;">Set Null</button>
      <button class="btn btn-default" (click)="selectedStatusFilter=''">Select Empty selectedStatusFilter</button>
      <button class="btn btn-default" (click)="disableToggle()">Disabled Toggle</button>
      <button class="btn btn-default" (click)="disableToggleReactive()">Disabled Toggle Reactive</button>


    </div>
  </div>
</form>
